import React, { useState } from "react";
import styles from "./Layout.module.scss";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import FooterComponent from "../FooterComponent/FooterComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import NavBar from "../NavBar2/NavBar";

type Props = {
  children?: React.ReactNode;
};

const Layout: React.FC<Props> = ({ children }, props) => {
  const isLogin = useSelector((state: RootState) => state.auth.token);
  const isDriver = localStorage.getItem("roles")?.includes("DELIVERY_USER");
  const [showNavbar, setShowNavbar] = useState(false);

  return (
    <>
      <NavBar showNavbar={showNavbar} setShowNavbar={setShowNavbar} />
      <div className={styles.Layout} {...props}>
        {isLogin && (
          <HeaderComponent
            openNavbar={isDriver ? () => setShowNavbar(true) : null}
          />
        )}
        {children}
        <FooterComponent />
      </div>
    </>
  );
};

export default Layout;
